import namor from "namor";
import generateRandomNumerousId from "../generateRandomNumerousId";

function generateRandomSubdomain(){
    return `${namor.generate({ words: 2, separator: "-", saltLength: 0 })}-${generateRandomNumerousId()}`;
}

export default generateRandomSubdomain;
